module.exports = __webpack_public_path__ + "media/img/payment-methods/unionpay-912edf16a39ca9808ff28d98363fc2f4.svg";